<template>
    <transition :duration="durationTransition" name="modal">
        <div class="modal__wrap" :class="name" v-show="show">
            <div class="modal__content">
                <div class="modal__head">
                    <slot name="head">{{ head }}</slot>
                </div>
                <div class="modal__body">
                    <slot name="body">{{ body }}</slot>
                </div>
                <div class="modal__actions" v-if="actionsSection">
                    <slot name="actions">{{ actions }}</slot>
                    <a class="btn btn--outline" v-if="closeAction" @click="close()">{{ closeText }}</a>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        components: {},
        name: 'ui-Modal',
        props: {
            name: String,
            durationTransition: {
                type: Number,
                default: 200,
            },
            head: {
                type: String,
                default: '',
            },
            body: {
                type: String,
                default: '',
            },
            actions: {
                type: String,
                default: '',
            },
            actionsSection: {
                type: Boolean,
                default: true,
            },
            closeText: String,
            closeAction: {
                type: Boolean,
                default: true,
            },
        },
        data: function() {
            return {
                show: false,
            };
        },
        mounted() {
            document.body.appendChild(this.$el);
        },
        destroyed() {
            this.$el.remove();
        },
        methods: {
            open: function() {
                this.show = true;
            },
            close: function() {
                this.show = false;
            },
        },
    };
</script>
